import { render, staticRenderFns } from "./log_table.vue?vue&type=template&id=56a10c1c&scoped=true&"
import script from "./log_table.vue?vue&type=script&lang=js&"
export * from "./log_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a10c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a10c1c')) {
      api.createRecord('56a10c1c', component.options)
    } else {
      api.reload('56a10c1c', component.options)
    }
    module.hot.accept("./log_table.vue?vue&type=template&id=56a10c1c&scoped=true&", function () {
      api.rerender('56a10c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/log_table.vue"
export default component.exports